import {Injectable} from '@angular/core';
import {AbstractDataServiceDtoAdapter} from 'src/app/modules/core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import {CountryDataService} from './countryData.service';
import {CountryModel} from '../../../api/entity/country.model';
import {CountryConverter} from '../../../api/entity/converter/country.converter';


@Injectable({providedIn: 'root'})
export class CountryDataServiceAdapter extends
    AbstractDataServiceDtoAdapter<CountryModel, CountryConverter> {
    constructor(dataService: CountryDataService, converter: CountryConverter) {
        super(dataService, converter);
    }
    newStoredEntityInstance(): CountryModel {
        return new CountryModel();
    }
}
